import request from "../utils/request";

export function getList (data) {
    return request({
        url: '/api/carts/',
        method: 'get',
        data
    })
}
export function getInfo (id) {
    return request({
        url: '/api/carts/' + id,
        method: 'get'
    })
}
export function Post (data) {
    return request({
        url: '/api/carts/',
        method: 'post',
        data
    })
}
